import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkModule } from '@app/directives/link.directive';
import { FeaturedNewsModule } from '@app/components/featured-news/featured-news.component';
import { MyNewsModule } from '@app/components/my-news/my-news.component';
import { OrganizationCalendarModule } from '@app/components/organization-calendar/organization-calendar.component';
import { BirthdaysModule } from '@app/components/birthdays/birthdays.component';
import { RestaurantMenuModule } from '@app/components/restaurant-menu/restaurant-menu.component';
import { RssFeedsModule } from '@app/components/rss-feeds/rss-feeds.component';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { CustomMyBlogsModule } from '../custom-my-blogs/custom-my-blogs.component';
import { CustomComplimentsWallModule } from '../custom-compliments-wall/custom-compliments-wall.component';
import { KpiChartsModule } from '@app/components/kpi-charts/kpi-charts.component';
import { InfoboxZoneModule } from '@app/components/infobox-zone/infobox-zone.component';
import { PowerBIModule } from '@app/components/power-bi/power-bi.component';

@Component({
  selector: 'cafcass-custom-today',
  templateUrl: './custom-today.component.html',
  styleUrls: ['./custom-today.component.scss']
})
export class CustomTodayComponent {

}
@NgModule({
  declarations: [
    CustomTodayComponent
  ],
  exports: [
    CustomTodayComponent
  ],
  imports: [
    CommonModule,
    LinkModule,
    InfoboxZoneModule,
    FeaturedNewsModule,
    MyNewsModule,
    CustomMyBlogsModule,
    CustomComplimentsWallModule,
    OrganizationCalendarModule,
    BirthdaysModule,
    RestaurantMenuModule,
    RssFeedsModule,
    HideParentIfEmptyModule,
    MarkComponentVisitedModule,
    FeatureToggleModule,
    KpiChartsModule,
    PowerBIModule
  ]
})
export class CustomTodayModule { }
